import buildSimpleStringFilter from '../buildSimpleStringFilter'

const MemoryFilter = buildSimpleStringFilter({
  key: 'memory',
  expandedOnInit: false,
})

export default MemoryFilter
